module.exports = {
          srcSet: __webpack_public_path__ + "public/images/9bf5c0ebe90a5ac634aeb4aad7edab17-1774.webp"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/9bf5c0ebe90a5ac634aeb4aad7edab17-1774.webp",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/9bf5c0ebe90a5ac634aeb4aad7edab17-1774.webp",
          toString:function(){return __webpack_public_path__ + "public/images/9bf5c0ebe90a5ac634aeb4aad7edab17-1774.webp"},
          
          width: 1774,
          height: 887
        }